import { memo, useMemo, useState } from "react";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import TitledTextArea from "@coworker/apprestructured/src/task-management/components/TitledTextArea/TitledTextArea";
import Highlight from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Highlight/Highlight";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";

const MAX_DESCRIPTION_LENGTH = 1000; //Logic otherwise kept in creator fragment.

function TitledTextAreaDemo() {
  const [value, setValue] = useState("");

  const error = useMemo(() => {
    if (value.length > MAX_DESCRIPTION_LENGTH) {
      return `Maximum ${MAX_DESCRIPTION_LENGTH} characters`;
    }
    return null;
  }, [value]);

  return (
    <Demo>
      <Name>TitledTextArea</Name>
      <Highlight>
        <TitledTextArea
          title="taskDescriptionString"
          label="taskDescriptionString"
          value={value}
          onChange={setValue}
          error={error}
        />
      </Highlight>
    </Demo>
  );
}

export default memo(TitledTextAreaDemo);
